import type { TaskResolutionEnum } from '@olv/ui-shared/enums/task.enums';
import type { WalletOwnerTypeEnum } from '@olv/ui-shared/models/wallet.model';

export interface WhitelistedWallet {
  id: string;
  walletAddress: string;
  blockchain: string;
  walletName: string;
  preparedBy: string;
  date: Date;
  withdrawalType: string;
  riskLevel: 'Unsupported' | 'NotAssessed' | 'Unknown' | 'Low' | 'Medium' | 'High' | 'Severe';
  status: 'Pending' | 'Approved' | 'Rejected' | 'Revoked';
  canApproveOrReject: boolean;
  documentId?: string;
  documentName?: string;
  comments?: string;
  resolvedByDisplayName?: string;
  resolvedAt?: Date;
  resolution?: TaskResolutionEnum;
  ownerType?: WalletOwnerTypeEnum;
  riskAssessmentCompleted: boolean;
  source?: WhitelistedWalletSourceEnum;
}

export enum WhitelistedWalletSourceEnum {
  SettlementSystem = 0,
  MerchantPortal = 1,
}
